// extracted by mini-css-extract-plugin
export default {"container":"Co-z","ratingLayout":"Do-z","ratingLabel":"Eo-z","nonInteractiveRatingLabel":"Fo-z"};